import { FormControl, FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedFormField } from '../../models/appliance-details-stepped/appliance-details-stepped-form-field.enum';
import { ApplianceDetailsSteppedIpsForm } from '../../models/appliance-details-stepped/appliance-details-stepped-ips-form.interface';
import { IpsPersonalDetailsForm } from '../../models/appliance-details-stepped/ips-personal-details-form.interface';
import { mockIpsPersonalDetailsForm } from './ips-personal-details-form.mock';
import { mockModelAndSerialNumberFieldset } from './model-and-serial-number-fieldset.mock';

export const mockApplianceDetailsSteppedIpsForm: ApplianceDetailsSteppedIpsForm =
  {
    [ApplianceDetailsSteppedFormField.ApplianceCategoryCode]: new FormControl(
      null
    ),
    [ApplianceDetailsSteppedFormField.ApplianceCode]: new FormControl(null),
    [ApplianceDetailsSteppedFormField.BrandCode]: new FormControl(null),
    [ApplianceDetailsSteppedFormField.ModelAndSerialNumber]: new FormGroup(
      mockModelAndSerialNumberFieldset
    ),
    [ApplianceDetailsSteppedFormField.PurchasePrice]: new FormControl(null),
    [ApplianceDetailsSteppedFormField.PurchaseDate]: new FormControl(null),
    [ApplianceDetailsSteppedFormField.PersonalDetails]:
      new FormGroup<IpsPersonalDetailsForm>(mockIpsPersonalDetailsForm),
  };
